import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/fulcrum': {
    width: 269,
    height: 512,
    paths: [
      {
        d: 'M70.8 164.1L35.4 207.7 0 164.1 35.4 120.6 70.8 164.1zM119.2 0L98.7 198.2 47.7 256 98.7 313.8 119.2 512V300.9L78.2 256 119.2 211.1V0zM198.9 164.1L234.3 207.7 269.7 164.1 234.3 120.6 198.9 164.1zM150.4 211.1L191.5 256 150.4 300.9V512L171 313.8 221.9 256 171 198.2 150.4 0V211.1z'
      }
    ]
  }
})
